import Vue from 'vue';
import App from './App';
import VueRouter from 'vue-router';

import Home from './components/Home.vue';
import CV from './components/CV.vue';
import Work from './components/Work.vue';

Vue.use(VueRouter);

const router = new VueRouter({
	mode:   'history',
	base:   __dirname,
	routes: [
		{path: '/', component: Home},
		{path: '/cv', component: CV},
		{path: '/work', component: Work}
	]
});


/* eslint-disable no-new */
new Vue({
	router,
	template:   '<App/>',
	components: {App}
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js